export default function MessagesPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Messages</h1>
      <p className="text-gray-500">Messaging system - coming soon</p>
    </div>
  )
}
